export default {
  methods: {
    formatAmount (number, curr, decimals) {
      let currency = curr
      try {
        let hasdecimals = decimals || number % 1 != 0
        if (hasdecimals) return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: currency }).format(number)
        else return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: currency, maximumFractionDigits: 0 , minimumFractionDigits: 0}).format(number)
      } catch (err) {
        return number
      }
    },
    timevalueToNumericDate: function (timevalue) {
      var options = { weekday: undefined, year: 'numeric', month: 'numeric', day: 'numeric' }
      return new Date(timevalue).toLocaleDateString('fr-FR', options)
    },
    timevalueToTime: function (timevalue) {
      var options = { hour: '2-digit', minute: '2-digit' }
      return new Date(timevalue).toLocaleTimeString('fr-FR', options)
    }
  }
}